/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DbrMessageEvent } from '../../models/dbr-message-event';

export interface BalloonsControllerSse$Params {
  eventid: string;
}

export function balloonsControllerSse(http: HttpClient, rootUrl: string, params: BalloonsControllerSse$Params, context?: HttpContext): Observable<StrictHttpResponse<DbrMessageEvent>> {
  const rb = new RequestBuilder(rootUrl, balloonsControllerSse.PATH, 'get');
  if (params) {
    rb.path('eventid', params.eventid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DbrMessageEvent>;
    })
  );
}

balloonsControllerSse.PATH = '/balloons/launch-sse/{eventid}';
